// Site-wide facts: main menu, contact details, design images.

import manifest from "@/public/d/manifest.json";

export const menu = [
  { href: "/", label: "Start" },
  { href: "/polsterei/", label: "Polsterei" },
  { href: "/sonnenschutz/", label: "Sonnenschutz" },
  { href: "/werkstatt/", label: "Werkstatt" },
  { href: "/kontakt/", label: "Kontakt" },
];

export const contact = {
  phone: "0711 / 1 84 19 75",
  tel: "tel:+497111841975",
  email: "kontakt@ideensprung.de",
  street: "Stuttgarter Str. 19",
  town: "70794 Filderstadt-Plattenhardt",
  hours: "nach Vereinbarung",
  googleReviews: "https://maps.google.com/?cid=3353107499196627972",
  route: "https://www.google.com/maps/dir/?api=1&destination=Stuttgarter+Str.+19,+70794+Filderstadt",
  // placeholders until the client sends the real profile urls
  instagram: "https://www.instagram.com/polsterei.ideensprung/",
  facebook: "https://www.facebook.com/polstereiideensprung/",
};

// An image of the design canvas, downloaded to public/d/ under its design id (see public/d/manifest.json).

type Entry = { file: string; w: number; h: number };
const files = manifest as Record<string, Entry>;

export function d(id: string): string {
  return `/d/${files[id]?.file ?? `${id}.jpg`}`;
}

export function size(id: string): { width: number; height: number } {
  const e = files[id];
  return { width: e?.w ?? 800, height: e?.h ?? 600 };
}

// recurring design images
export const img = {
  emblem: "7fc9837dd31e2c433011bdb526a5edb1", // chair emblem, header
  seal: "519d33dcc369e12019bd621a42673fd2", // round stamp: tag, footer, success card
  pin: "8e0339626a5ccc543fe285359c511937", // brass pin of the workshop note
  nathalie: "2ab604fd282d8a2481474a83c0f90fa6",
  alexandra: "c8b257f56edccc88a215f86345ee6f32",
};
